import React, { useState, useEffect } from 'react';
import { Sparkles, Headphones, Mic, ArrowRightLeft, Volume2, Clock, Image as ImageIcon } from 'lucide-react';
import SpeechTTS from './SpeechTTS';
import SpeechSTT from './SpeechSTT';
import SpeechSTS from './SpeechSTS';
import SpeechHistory from './SpeechHistory';
import StudioImages from './StudioImages';

const buildTabs = (features) => [
  { id: 'tts', label: 'Synthèse Vocale', icon: Volume2, available: true },
  { id: 'stt', label: 'Transcription', icon: Mic, available: true },
  { id: 'sts', label: 'Conversion', icon: ArrowRightLeft, available: true },
  ...(features.studio_images !== false ? [{ id: 'images', label: 'Génération d\'images', icon: ImageIcon, available: true }] : []),
  { id: 'history', label: 'Historique', icon: Clock, available: true },
];

const SpeechStudio = ({ user }) => {
  const [activeTab, setActiveTab] = useState('tts');
  const [features, setFeatures] = useState({ studio_images: true }); // default on, override après fetch

  useEffect(() => {
    const token = localStorage.getItem('oracle_token');
    fetch('/api/capabilities/features', { headers: { 'Authorization': `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(d => d?.features && setFeatures(d.features))
      .catch(() => {});
  }, []);

  const tabs = buildTabs(features);

  return (
    <div style={{ padding: '28px 32px', height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px', flexShrink: 0 }}>
        <div>
          <h1 style={{ fontSize: '24px', fontWeight: 700, color: 'var(--text)', margin: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Sparkles size={26} style={{ color: '#3b82f6' }} />
            ITRIIA Studio
          </h1>
          <p style={{ fontSize: '13px', color: 'var(--text-secondary)', margin: '4px 0 0 0' }}>
            Voix, transcription, conversion audio et génération d'images
          </p>
        </div>
      </div>

      {/* Onglets */}
      <div style={{
        display: 'flex', gap: '4px', padding: '4px',
        background: 'var(--card-bg)', border: '1px solid var(--card-border)',
        borderRadius: '12px', marginBottom: '20px', flexShrink: 0, width: 'fit-content',
      }}>
        {tabs.map(tab => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => tab.available && setActiveTab(tab.id)}
              style={{
                display: 'flex', alignItems: 'center', gap: '8px',
                padding: '9px 18px', borderRadius: '9px', border: 'none',
                cursor: tab.available ? 'pointer' : 'default',
                background: isActive ? 'rgba(29,78,216,0.15)' : 'transparent',
                color: isActive ? '#3b82f6' : tab.available ? 'var(--text-secondary)' : 'var(--text-muted)',
                fontWeight: isActive ? 600 : 500, fontSize: '13px',
                transition: 'all 0.15s', opacity: tab.available ? 1 : 0.5,
              }}
              title={tab.available ? tab.label : `${tab.label} — Bientôt disponible`}
            >
              <Icon size={15} />
              {tab.label}
              {!tab.available && (
                <span style={{
                  fontSize: '9px', padding: '2px 6px', borderRadius: '4px',
                  background: 'rgba(107,114,128,0.15)', color: 'var(--text-muted)',
                  fontWeight: 600, letterSpacing: '0.3px',
                }}>
                  SOON
                </span>
              )}
            </button>
          );
        })}
      </div>

      {/* Contenu onglet */}
      <div style={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
        {activeTab === 'tts' && <SpeechTTS />}

        {activeTab === 'stt' && <SpeechSTT />}

        {activeTab === 'sts' && <SpeechSTS />}
        {activeTab === 'images' && <StudioImages />}
        {activeTab === 'history' && <SpeechHistory />}
      </div>
    </div>
  );
};

const ComingSoon = ({ icon: Icon, title, description }) => (
  <div style={{
    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
    height: '100%', gap: '16px', opacity: 0.6,
  }}>
    <div style={{
      width: 72, height: 72, borderRadius: '50%',
      background: 'rgba(59,130,246,0.08)', border: '1px solid rgba(59,130,246,0.15)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <Icon size={28} style={{ color: '#3b82f6' }} />
    </div>
    <h3 style={{ fontSize: '18px', fontWeight: 600, color: 'var(--text)', margin: 0 }}>{title}</h3>
    <p style={{ fontSize: '14px', color: 'var(--text-secondary)', maxWidth: '400px', textAlign: 'center', lineHeight: 1.6 }}>
      {description}
    </p>
    <span style={{
      padding: '6px 16px', borderRadius: '20px',
      background: 'rgba(59,130,246,0.1)', border: '1px solid rgba(59,130,246,0.2)',
      color: '#3b82f6', fontSize: '12px', fontWeight: 600,
    }}>
      Bientôt disponible
    </span>
  </div>
);

export default SpeechStudio;
